<div class="wrapper">
    <div class="main">
        <div class="section section-white">
            <div class="container">

                <div class="row">
                    <div class="col-md-4 col-lg-4 col-sm-4 ml-auto mr-auto text-center title">
                        <div style="width: 100%;" class="card-image">

                            <img style="width: 100%;" crossorigin="anonymous" class="img-responsive"
                                src="./assets/img/website_2/image_11_background.png" />
                        </div>
                    </div>
                </div>


                <div class="row">

                    <div class="col-md-8 ml-auto mr-auto" [innerHTML]="Data.full_text">

                    </div>


                </div>

                <div class="row mt-n5">
                    <div class="col-md-8 ml-auto mr-auto text-center title">

                        <h3 class="title-uppercase"><small>Written by {{Data.owner}}<br>{{Data.title}}</small></h3>                 
                        <h6 class="title-uppercase">Date: {{Data.created}}</h6>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>